import { Outlet } from "react-router-dom";

import { VendorShell } from "@/components/vendor/vendor-shell";

export function VendorLayout() {
  return (
    <VendorShell title="Seller">
      <Outlet />
    </VendorShell>
  );
}
